import React from 'react';

import {
	getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment,
	Product,
	STORAGE_KEYS,
	type StorageAdapter,
	UpgradeModalComponent,
} from '../../utils';
import { ConfluenceAfterStandardUpgradeAIModal } from '../ConfluenceAfterStandardUpgradeAIModal';

export const ConfluenceUpgradeFreePoolExperimentModalPostUpgrade = ({
	storageAdapter,
}: {
	storageAdapter: StorageAdapter;
}) => {
	const modalToShow = getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment(
		storageAdapter,
		Product.Confluence,
	);

	const cleanExperimentLocalStorageAttributes = () => {
		storageAdapter.removeItem(STORAGE_KEYS.Confluence.first);
		storageAdapter.removeItem(STORAGE_KEYS.Confluence.second);
	};

	switch (modalToShow) {
		case UpgradeModalComponent.ConfluenceAfterStandardUpgradeAIModal:
			return (
				<ConfluenceAfterStandardUpgradeAIModal
					onInteractionComplete={cleanExperimentLocalStorageAttributes}
				/>
			);
		case UpgradeModalComponent.None:
		default:
			return null;
	}
};
